import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { arrayMoveImmutable as arrayMove } from 'array-move';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import { infoRequest } from '../../actions';
import { selectInfo } from '../../selectors';
import types from '../../actionTypes';

const { takeLatest, put, select } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    const info = yield select(selectInfo, meta.categoryId);
    const orderedInfo = arrayMove(info, meta.oldIndex, meta.newIndex);

    const batch = firestore.batch();

    try {
        for (const lang of config.app.languages) {
            for (let index = 0; index < orderedInfo.length; index += 1) {
                if (orderedInfo[index]) {
                    const { id } = orderedInfo[index];
                    const ref = yield firestore.doc(`languages/${lang}/infoCategories/${meta.categoryId}/info/${id}`);
                    batch.update(ref, {
                        order: index,
                    });
                }
            }
        }
        yield batch.commit();
        yield put(infoRequest(meta.categoryId, { silent: true }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.info.order' }));
    }
}
export default function* () {
    yield takeLatest(types.UPDATE_INFO_ORDER, handler);
}
